import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Zhambyl_obl.png'
import _imports_1 from '@/assets/images/jambyl1.jpg'
import _imports_2 from '@/assets/images/jambyl2.jpg'
import _imports_3 from '@/assets/images/jambyl3.jpg'
import _imports_4 from '@/assets/images/jambyl4.jpg'
import _imports_5 from '@/assets/images/jambyl5.jpg'
import _imports_6 from '@/assets/images/jambyl6.jpg'
import _imports_7 from '@/assets/images/jambyl7.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Жамбылская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Жамбылская область всегда привлекала внимание иностранных туристов, ведь именно здесь расположено множество исторических достопримечательностей, сохранившихся со времен Великого Шелкового пути, и все основные объекты региона сосредоточены вдоль его ветви Сайрам – Кордай. Статистика туризма в Казахстане утверждает, что самыми посещаемыми достопримечательностями в этой местности являются дворцовый комплекс Акыртас, мавзолеи Айша-биби и Бабаджи-хатун, Карахана, городище Актобе-Степнинское. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Туры На Природу")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Поездки в Аксу-Жабаглинский природный заповедник стали наиболее востребованными в последние годы у компаний, которые организуют внутренний туризм, статистика показывает, что в такое путешествие отправляются преимущественно казахстанцы, а самым лучшим сезоном для организации туров является весна. На западных отрогах Таласского Алатау, где раскинулся заповедник, весной можно наблюдать цветение тысяч тюльпанов, многие из которых занесены в Красную книгу Республики Казахстан. Немало интереса вызывают и устраиваемые несколькими турфирмами обзорные экскурсии в ущелье Коксай, оно тоже расположено в этих предгорьях. ")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Путешествия С Другими Целями")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Поправить здоровье можно в Меркенском ущелье, где из-под земли бьют целебные минеральные и радоновые источники. Наряду с оздоровительным и другими традиционными видами туризма в регионе можно организовать тур практически с любой целью – историко-культурной, паломнической, конноспортивной или приключенческой. Последние годы здесь наблюдается устойчивая положительная динамика увеличения туристских потоков – данные предоставила статистика туризма по Жамбылской области. ")
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "5750")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "16,9")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "139260")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "4721")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как развивается туризм в Жамбылской области? Развитию туризма уделяют большое внимание местные власти, формируя «правильный» туристический имидж и вкладывая денежные средства в объекты профильной инфраструктуры. "),
        /*#__PURE__*/_createVNode("p", null, " В областном центре – городе Тараз – был реализован культурно-исторический проект «Городище мастеров древнего Тараза». Только в 2019 год у в нем побывало более 5,5 тысяч гостей, из них более полутысячи – иностранцы. Интересен и еще один проект региона – этно-культурный комплекс «Шахристан», в развитие которого было инвестировано 3 миллиарда тенге. В состав комплекса входят выставочный центр, музей, картинная галерея, импровизированный городок. А в рамках реализации государственного проекта «Рухани Жангыру» началось строительство горнолыжного комплекса «Каралма». ")
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "regio-swiper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_5
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_6
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_7
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}